import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cohrex-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CardComponent {
  @Input() padding: string = 'tw-px-4 tw-py-6';
  @Input() className: string = '';
}
